import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import FactoryList from './factoryList';
import { useLocation, useNavigate } from "react-router-dom";

const FactoryManagement = ({ }: any) => {
    const [selectedTab, setSelectedTab] = useState<any>();    
    const navigate = useNavigate(); 

    const {pathname} = useLocation();    
    useEffect(()=>{        
        if((pathname.split('/')).includes('pending-approval')){
            setSelectedTab(1);
        } else {
            setSelectedTab(0);
        }
    },[pathname])
    
    const handleTabChange = (e: any, value: any) => {
        setSelectedTab(value);        
        if(value===0){
            navigate(`${'/assets/factory-management'}`)
        } else {
            navigate(`${'/assets/factory-management/pending-approval/all'}`)
        }        
    };    

        return (
            <>
                {selectedTab === 0 && <FactoryList onTabChange={handleTabChange} selectedTab={selectedTab} filterStatus='list' />}
                {selectedTab === 1 && (
                    <FactoryList onTabChange={handleTabChange} selectedTab={selectedTab} filterStatus='waiting_for_approval' />
                )}
            </>
        );
};

const mapStateToProps = (state: any) => ({});

export default connect(mapStateToProps)(FactoryManagement);
